import { render, staticRenderFns } from "./TextFieldSign.vue?vue&type=template&id=5913b2c3&"
import script from "./TextFieldSign.vue?vue&type=script&lang=js&"
export * from "./TextFieldSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports